import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    CodeBlock, BlockType, SettingType, Define, ValidationMessage, SettingState,
    SettingControlType,
} from '@appblocks/codegeneration/types';
import * as tios from './tios';

export default class LUIS extends BaseFeature {
    constructor() {
        super();
        this.name = 'LUIS (BLE Dashboard)';
        this.id = 'luis';
        this.icon = 'MdPhoneIphone';
        this.requirements = ['tios'];
        this.fileLinks = [
            // 'luis\\luis.tbs',
            // 'luis\\luis.tbh',
        ];
        this.files = [
            'luis.xtxt',
            'libraries/luis/luis.tbh',
            'libraries/luis/luis.tbs',
            'libraries/stgcmd/stgcmd.tbh',
            'libraries/stgcmd/stgcmd.tbs',
            'settings_web.html',
        ];
        const settings = [
            {
                id: 'ENABLED',
                name: 'LUIS Enabled',
                settingType: SettingType.OPTION,
                required: true,
                default: '0',
                options: [
                    {
                        name: 'Disabled',
                        value: '0',
                    },
                    {
                        name: 'Enabled',
                        value: '1',
                    },
                ],
            },
            {
                id: 'BTENABLED',
                name: 'Bluetooth Enabled',
                settingType: SettingType.HIDDEN,
                required: true,
                default: '1',
                options: [
                    {
                        name: 'Disabled',
                        value: '0',
                    },
                    {
                        name: 'Enabled',
                        value: '1',
                    },
                ],
            },
            {
                id: 'WEBENABLED',
                name: 'Web Enabled',
                settingType: SettingType.HIDDEN,
                required: true,
                readonly: true,
                default: '0',
                options: [
                    {
                        name: 'Disabled',
                        value: '0',
                    },
                    {
                        name: 'Enabled',
                        value: '1',
                    },
                ],
            },
            {
                id: 'START_ENABLED',
                name: 'Enabled at Boot',
                settingType: SettingType.OPTION,
                required: true,
                default: '1',
                options: [
                    {
                        name: 'Disabled',
                        value: '0',
                    },
                    {
                        name: 'Enabled',
                        value: '1',
                    },
                ],
            },
            {
                id: 'PASSWORD',
                name: 'Password',
                settingType: SettingType.HIDDEN,
                default: '',
            },
            {
                id: 'GROUPS',
                name: 'Groups',
                settingType: SettingType.ARRAY,
                refId: 'luis_group',
                controlType: SettingControlType.TABS,
                required: true,
                default: [] as BaseFeature[],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getDefines(): Array<Define> {
        const defines: Define[] = [
            {
                name: 'LUIS_HTML_FILE',
                value: '"luis.html"',
            },
        ];
        if (this.getSettingValue('BTENABLED') === '0') {
            defines.push(
                {
                    name: 'LUIS_BT_ENABLED',
                    value: '0',
                },
            );
        }

        return defines;
    }

    getDependencies() {
        const dependencies = [
            'stg',
            'stgcmd_lib',
        ];

        const { project } = this;
        if (project.device.platform !== 'WM2000') {
            if (this.getSettingValue('BTENABLED') === '1') {
                dependencies.push('bt');
            }
        }

        if (this.getSettingValue('WEBENABLED') === '1') {
            dependencies.push('httpserver');
        }

        if (this.getSettingValue('BTENABLED') === '1') {
            dependencies.push('bt');
        }

        return dependencies;
    }

    getFiles(): Array<string> {
        let { files } = this;
        // if (this.getSettingValue('BTENABLED') === '1') {
        files = files.concat([
            'luis.html',
        ]);
        // }
        if (this.getSettingValue('WEBENABLED') === '1') {
            files = files.concat([
                'bundle.js.gz',
            ]);
        }
        return files;
    }

    getState(settingId: string): SettingState {
        if (settingId !== 'ENABLED' && this.getSettingValue('ENABLED').toString() === '0') {
            return SettingState.HIDDEN;
        }
        switch (settingId) {
            case 'ENABLED':
                return SettingState.ENABLED;
            default:
                return SettingState.ENABLED;
        }
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'tios':
                return tios.getCodeBlocks(this);
            default:
                return [];
        }
    }

    getDetails(): string {
        return `
# LUIS Bluetooth Dashboard

![LUIS App](/static/img/luis_portrait.png "Title")

Use this dashboard to configure your device via Bluetooth.


        `;
    }
}
